import { gql, useMutation } from '@apollo/client'
import { useNavigate } from '@reach/router'
import { useNotification } from '@btime/react-messager'

import { checklistsClient } from '../../../../utils/apollo/api'

const MUTATION = gql`
  mutation UpsertChecklistType($input: ChecklistTypeInput) {
    upsertChecklistType(input: $input) {
      id
      name
    }
  }
`

export const useSaveChecklistType = onSuccess => {
  const notify = useNotification()
  const navigate = useNavigate()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['ChecklistTypes'], client: checklistsClient })

  const handleRequest = name => {
    const input = { name }

    return request({ variables: { input } }).then(resp => {
      if (!resp.errors) {
        if (!!onSuccess) onSuccess(resp.data?.upsertChecklistType)
      } else {
        notify.error({ title: 'Ocorreu um erro ao salvar!' })
      }
    })
  }

  return [handleRequest, state]
}
